import { ButtonWithDropdown, DropdownItem } from '@ardoq/dropdown-menu';
import { DropdownSize } from '@ardoq/dropdown-menu-ui';
import { AddIcon } from '@ardoq/icons';
import { t } from '@ardoq/i18n';
import { useFormattingContext } from '../useFormattingContext';

type AddNewFormattingRuleButtonProps = {
  buttonOptions: Partial<DropdownItem>[];
};

export const AddNewFormattingRuleButton = ({
  buttonOptions,
}: AddNewFormattingRuleButtonProps) => {
  const { i18nLocale } = useFormattingContext();
  return (
    <div>
      <ButtonWithDropdown dropdownSize={DropdownSize.S} options={buttonOptions}>
        <AddIcon />
        {t(
          i18nLocale,
          'perspectives:addNewFormattingRuleButton.addConditional',
          'Add conditional formatting'
        )}
      </ButtonWithDropdown>
    </div>
  );
};
